export class AppConstants {
    // Auth
    static readonly forgotPassword = 'forgot-password';
    static readonly resetPassword = 'reset-password';
    static readonly signIn = 'sign-in';
    static readonly signUp = 'sign-up';
    static readonly activateAdminAccount = 'activate-admin-account';
    static readonly activateCustomerAccount = 'activate-customer-account';

    // Authenticated routes
    static readonly signOut = 'sign-out';
    static readonly notFound = '404-not-found';

    // Admin routes
    static readonly dashboard = 'dashboard';
    static readonly example = 'example';
    static readonly profile = 'profile';
    static readonly sales = 'sales';
    static readonly purchasing = 'purchasing';

    static readonly products = 'products';
    static readonly productFamily = 'product-family';
    static readonly inventory = 'inventory';
    static readonly inventoryReconciliation = 'inventory-reconciliation';
    static readonly customers = 'customers';
    static readonly suppliers = 'suppliers';
    static readonly purchaseOrders = 'purchase-orders';
    static readonly discounts = 'discounts';
    static readonly marketing = 'marketing';
    static readonly marketplace = 'marketplace';
    static readonly saleOrders = 'sale-orders';
    static readonly saleQuotations = 'sale-quotations';
    static readonly shipments = 'shipments';
    static readonly shipmentManagement = 'shipment-management';
    static readonly team = 'team';

    // Company routes
    static readonly company = 'company';
    static readonly viewCompany = 'view';
    static readonly editCompany = 'edit';

}
